import { render } from "./Ruler.vue?vue&type=template&id=5bdf3d00&scoped=true"
import script from "./Ruler.vue?vue&type=script&lang=js"
export * from "./Ruler.vue?vue&type=script&lang=js"

import "./Ruler.css?vue&type=style&index=0&id=5bdf3d00&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bdf3d00"]])

export default __exports__